export interface IInnerLayer {
  addToMap: () => void;
  removeFromMap: () => void;
}
